import {createReducer} from "typesafe-actions";
import {
    COMPLETE, getAllTreeAsync,
    getOneFixtureAsync,
    getTreeFilterAsync,
    getTreeLiveAsync,
    getTreeRatingAsync,
    getTreeResultAsync,
    LOADING,
    SET_RESULT_TAB
} from '../actions';

export const loading = createReducer(false)
    .handleAction(LOADING, () => true)
    .handleAction(COMPLETE, () => false)
    .handleAction(SET_RESULT_TAB, () => true)

    .handleAction(getOneFixtureAsync.success, () => false)
    .handleAction(getOneFixtureAsync.failure, () => false)
    .handleAction(getOneFixtureAsync.cancel, () => false)

    .handleAction(getTreeResultAsync.success, () => false)
    .handleAction(getTreeResultAsync.failure, () => false)
    .handleAction(getTreeResultAsync.cancel, () => false)

    .handleAction(getTreeLiveAsync.success, () => false)
    .handleAction(getTreeLiveAsync.failure, () => false)
    .handleAction(getTreeLiveAsync.cancel, () => false)

    .handleAction(getTreeFilterAsync.success, () => false)
    .handleAction(getTreeFilterAsync.failure, () => false)
    .handleAction(getTreeFilterAsync.cancel, () => false)

    .handleAction(getAllTreeAsync.success, () => false)
    .handleAction(getAllTreeAsync.failure, () => false)
    .handleAction(getAllTreeAsync.cancel, () => false)

    .handleAction(getTreeRatingAsync.success, () => false)
    .handleAction(getTreeRatingAsync.failure, () => false)
    .handleAction(getTreeRatingAsync.cancel, () => false)
